var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyRegisterShortcut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1513 12.418H49.1243C45.149 12.418 41.9241 15.6433 41.9241 19.6188C41.9241 23.5942 45.149 26.8196 49.1243 26.8196H57.8252L14.472 70.1747C11.6968 72.9501 11.6968 77.5255 14.472 80.3009C17.2472 83.0762 21.8228 83.0762 24.598 80.3009L67.9507 36.9458V45.6468C67.9507 49.6223 71.176 52.8477 75.1513 52.8477C79.1266 52.8477 82.3515 49.6223 82.3515 45.6468V19.6188C82.3515 15.6433 79.1266 12.418 75.1513 12.418Z",
    fill: "#4084FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyRegisterShortcut);
export default __webpack_public_path__ + "static/media/company_register_shortcut.647ca23ff9624fb0532d5fe204e39cd2.svg";
export { ForwardRef as ReactComponent };